import { render, staticRenderFns } from "./CloneBudgetForm.vue?vue&type=template&id=2c266f85"
import script from "./CloneBudgetForm.vue?vue&type=script&lang=js"
export * from "./CloneBudgetForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports